module.exports = __webpack_public_path__ + "static/img/shareFacebook.8027c34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/shareFacebook.svg
// module id = 29Np
// module chunks = 0